<template>
  <div class="project-entry breakdown-popup ">
    <div class="background-click-detector" @click="closePopup()"></div>
    <div class="project-entry-wrapper">
      <div class="popup-exit" @click="closePopup">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          xmlns:avocode="https://avocode.com/"
          id="SVGDoc"
          width="22"
          height="27"
          version="1.1"
          viewBox="0 0 22 27"
        >
          <defs />
          <desc>Generated with Avocode.</desc>
          <g>
            <g>
              <title>close</title>
              <path
                d="M9.15986,25.54362c0,0.80252 -0.62895,1.45636 -1.40274,1.45636h-6.35636c-0.77379,0 -1.40274,-0.65384 -1.40274,-1.45636v-23.31371c0,-0.80309 0.62895,-1.45683 1.40274,-1.45683h6.35636c0.77379,0 1.40274,0.65374 1.40274,1.45683c0,0.80328 -0.62895,1.45693 -1.40274,1.45693h-4.95481v20.39928h4.95481c0.77379,0 1.40274,0.65374 1.40274,1.4575zM21.87376,13.93016c0.02015,0.35725 -0.12231,0.74883 -0.39876,1.03903l-4.80282,4.15678c-0.22542,0.23775 -0.58031,0.39129 -0.9588,0.39129c-0.37885,0 -0.73373,-0.15354 -0.99945,-0.43163c-0.54467,-0.56829 -0.54467,-1.49174 0.00119,-2.05879l1.94395,-1.68324h-9.6947c-0.77379,0 -1.40393,-0.65355 -1.40393,-1.45731c0,-0.80252 0.63014,-1.45636 1.40393,-1.45636h9.66263l-1.87135,-1.61791c-0.5852,-0.60673 -0.58639,-1.53074 -0.04172,-2.09885c0.26572,-0.27752 0.6206,-0.43068 0.99945,-0.43068c0.37849,0 0.73338,0.15249 0.99909,0.43068l4.71973,4.07524c0.31924,0.33197 0.4617,0.72327 0.44155,1.14174z"
                fill="#7b7b8a"
                fill-opacity="1"
              />
            </g>
          </g>
        </svg>
      </div>
      <div class="project-content-wrapper">
        <div class="entry-title">{{ titleGenerated }}</div>
        <div class="form-input-wrapper">
          <label class="form-label">
            <span>{{ $t('purchase_create_edit.name') }}</span>
          </label>
          <v-text-field
            class="universal-vdialog-textfield"
            v-model="purchase.title"
            required
          ></v-text-field>
        </div>
        <div class="form-input-wrapper">
          <label class="form-label">
            <span>{{ $t('purchase_create_edit.description') }}</span>
          </label>
          <textarea class="form-textarea" v-model="purchase.description" />
        </div>

        <div class="project-dropdowns clanovi-tima-wrapper">
          <form-autocomplete-single
            :label="$t('purchase_create_edit.assigned_person')"
            type="clanovi_tima"
            id="clanovi-tima-eventi"
            ref="clan"
            :placeholder="$t('purchase_create_edit.select_person')"
            :items="clanovi"
          ></form-autocomplete-single>
        </div>
         
        <div class="three-row-elements">
          <div class="form-input-wrapper">
            <label class="form-label">
              <span>{{ $t('purchase_create_edit.quantity') }}</span>
            </label>
            <input
              type="text"
              class="form-input"
              v-model="purchase.quantity"
              @change="final_price = purchase.price * purchase.satnica"
              oninput="this.value = this.value.replace(',','.').replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0');"
            />
          </div>
         
        </div>
        <div class="wrapp-checkbox">
            <div class="planer-mark-txt">
              <svg class="update-event-spin popup-event-spin" viewBox="0 0 50 50" style="display:none">
                <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="8"></circle>
              </svg>

              <div :class="['task-checkbox', 'popup-check', purchase.aquired ? 'active' : '']" @click="valChange()">
                <div class="check"></div>
            </div>
              <div class="planer-task-txt">{{ $t('purchase_create_edit.purchased') }}</div>
            </div> 

          </div>
        <div class="button-create-wrapper">
          <div @click="saveData" class="button-default button-create">
            <span>{{ $t("repetitive.save") }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import formAutocomplete from "@/components/formElements/formAutocompleteSingle.vue";
import CustomDropdown from "@/components/generalComponents/CustomDropdown.vue";
import FormAutocompleteSingle from "../formElements/formAutocompleteSingle.vue";
import $ from "jquery"
export default {
  components: { formAutocomplete, CustomDropdown, FormAutocompleteSingle },
  name: "PurchaseCreateEdit",
  props: [
    "is_edit",
    "purchase",
    "clanovi",
    "edit_team_members",
    "drop_items",
    "service_types",
  ],
 
  methods: {
    valChange()
    {
      this.purchase.aquired = !this.purchase.aquired
    },
    
    closePopup() {
      this.$emit("closeMe");
    },

    saveData()
    {
      this.purchase.person_id = this.selected_person.results_final.uid != "" ?  this.selected_person.results_final.uid : null;
      this.purchase.quantity = this.purchase.quantity ? parseInt(this.purchase.quantity) : 1;


      if(this.is_edit)
      {
        delete this.purchase["odvjetnik"]
        delete this.purchase["deadline"]
      }
      
      this.is_edit ? this.$emit("edit", {id: this.purchase.id, data: this.purchase}) : this.$emit("create", this.purchase);
    },
  
    getDate(date) {
      return moment(date).format("DD.MM.YYYY.");
    },
  },
  data() {
    return {
      final_price: 0.0,
      selected_person : null,
      start_value : null
    };
  },
  computed: {
    titleGenerated() {
      return this.is_edit ? this.$t('purchase_create_edit.edit_item') : this.$t('purchase_create_edit.add_new_item');
    },
  },
  mounted() {
    this.selected_person= this.$refs.clan.$data;
    if(this.is_edit && this.purchase.odvjetnik)
    {
      let tmp_odvj = this.purchase.odvjetnik;

    this.selected_person.results_final = { name: tmp_odvj.ime + " " + tmp_odvj.prezime, uid: tmp_odvj.uid }
      }
  },
};
</script>
